var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBuilding = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 7H7v2h2V7ZM7 11h2v2H7v-2ZM15 7h2v2h-2V7ZM17 11h-2v2h2v-2ZM13 7v2h-2V7h2ZM13 13v-2h-2v2h2Z",
  fill: "#191C29",
  fillOpacity: 0.54
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m21 5-9-3-9 3v16h18V5Zm-9-.892 7 2.334V15H5V6.442l7-2.334ZM5 17v2h14v-2H5Z",
  fill: "#191C29",
  fillOpacity: 0.54
})));
export default SvgBuilding;